export default {
    signup: "Sign up",
    login: "Log in",
}